import React, { useState } from "react";
import "./id-card-config.scss";

const CharacterCertificate = () => {


    const CharacterStudents = [
        {
            name: "U. Sathvika",
            father: "U. Raviteja",
            mother: "U. Naga Swetha",
            admission: "252628",
            className: "PP-1",
            section: "A",
            course: "PRE PRIMARY",
            dob: "09 Feb 2021",
            curriculum: "SSC",
            academicYear: "2026-27"
        },
        {
            name: "Rahul Kumar",
            father: "Ramesh Kumar",
            mother: "Sunita Kumar",
            admission: "252629",
            className: "1st",
            section: "B",
            course: "PRIMARY",
            dob: "14 Aug 2019",
            curriculum: "CBSE",
            academicYear: "2026-27"
        }
    ];

    const [searchStudent, setSearchStudent] = useState("");
    const [showStudentList, setShowStudentList] = useState(false);
    const [formData, setFormData] = useState({
        academicYear: "",
        curriculum: "",
        className: "",
        section: "",

        student: "",
        father: "",
        mother: "",
        admissionNo: "",
        course: "",
        dob: "",

        certificateNo: "CC/36/2026",
        issueDate: "2026-06-19",
        place: "Vijayawada",

        // Editable Certificate Content
        firstParagraph:
            "This is to certify that",
        secondParagraph:
            "During his/her entire period of association with this institution, the student has consistently exhibited exemplary conduct, moral integrity, and a spirit of cooperation. He/She has been sincere in studies, respectful towards teachers and peers, and has actively contributed to the school's ethos.",

        thirdParagraph:
            "We take great pleasure in certifying that his/her character is above reproach and we wish the student continued success and happiness in all future endeavors."
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const selectStudent = (stu) => {
        setFormData(prev => ({
            ...prev,
            student: stu.name,
            father: stu.father,
            mother: stu.mother,
            admissionNo: stu.admission,
            className: stu.className,
            section: stu.section,
            course: stu.course,
            dob: stu.dob,
            curriculum: stu.curriculum,
            academicYear: stu.academicYear
        }));
        setSearchStudent(stu.name);
        setShowStudentList(false);
    };

    const filteredStudents = CharacterStudents.filter(item =>
        item.name
            .toLowerCase()
            .includes(searchStudent.toLowerCase())
    );

    const displayValue = (value) => {
        return value && value.toString().trim() !== ""
            ? value
            : "________";
    };

    const formatDate = (date) => {

        if (!date)
            return "________";

        const d = new Date(date);
        return d.toLocaleDateString("en-GB", {

            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    return (
        <div className="mt-3">
            {/* FILTER SECTION */}
            <div className="card no-print">
                <div className="card-header"> Generate Character Certificate </div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <label>Academic Year</label>
                            <select
                                className="form-select"
                                name="academicYear"
                                value={formData.academicYear}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>2026-27</option>
                                <option>2025-26</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>Curriculum</label>
                            <select className="form-select" name="curriculum" value={formData.curriculum} onChange={handleChange}>
                                <option value="">Select </option>
                                <option>SSC</option>
                                <option>CBSE</option>
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label>Class</label>
                            <select className="form-select" name="className" 
                                value={formData.className}
                                onChange={handleChange}
                            >
                                <option value=""> Select</option>
                                <option>PP-1</option>
                                <option>PP-2</option>
                                <option>1st</option>
                                <option>2nd </option>
                            </select>
                        </div>
                        
                         <div className="col-md-3">
                            <label>
                                Section
                            </label>
                            <select
                                className="form-select"
                                name="section"
                                value={formData.section}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select
                                </option>
                                <option>
                                    A
                                </option>
                                <option>
                                    B
                                </option>
                            </select>
                        </div>
                        <div className="col-md-3 position-relative">
                            <label>
                                Student
                            </label>
                            <input
                                className="form-control"
                                value={searchStudent}
                                autoComplete="off"
                                onChange={(e) => {
                                    setSearchStudent(e.target.value);
                                    setShowStudentList(true);
                                }}
                                onFocus={() => setShowStudentList(true)}
                            />
                            {
                                showStudentList && searchStudent &&
                                <div className="student-list">
                                    {
                                        filteredStudents.map((stu, index) => (
                                            <div
                                                key={index}
                                                onMouseDown={() => selectStudent(stu)}
                                            >
                                                <b>
                                                    {stu.name}
                                                </b>
                                                <br />
                                                Father :
                                                {stu.father}
                                                <br />
                                                Mother :
                                                {stu.mother}
                                            </div>
                                        ))
                                    }
                                </div>
                            }
                        </div>

                        <div className="col-md-3">
                            <label>
                                Certificate No
                            </label>
                            <input
                                className="form-control"
                                name="certificateNo"
                                value={formData.certificateNo}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>
                                Issue Date
                            </label>
                            <input
                                type="date"
                                className="form-control"
                                name="issueDate"
                                value={formData.issueDate}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>
                                Place
                            </label>
                            <input
                                className="form-control"
                                name="place"
                                value={formData.place}
                                onChange={handleChange}
                            />
                        </div>

                        {/* EDITABLE CONTENT */}
                        <div className="col-md-6 mt-3">
                            <label>
                                First Paragraph
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                name="firstParagraph"
                                value={formData.firstParagraph}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mt-3">
                            <label>
                                Character Paragraph
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                name="secondParagraph"
                                value={formData.secondParagraph}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mt-3">
                            <label>
                                Closing Paragraph
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                name="thirdParagraph"
                                value={formData.thirdParagraph}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* CERTIFICATE */}
            <div className="print-area">
                <div className="certificate">
                    <div className="certificate-border">
                        {/* HEADER FIXED */}
                        <div className="school-header">
                            <img
                                src="https://www.srinitheplayschool.com/img/logo.png"
                                className="school-logo"
                                alt="logo"
                            />
                            <div>
                                <h2>
                                    SRINI THE PLAY SCHOOL & ACADEMY
                                </h2>
                                <p>
                                    Vijayawada, Andhra Pradesh

                                    <br />

                                    Contact : 7893077007

                                </p>
                            </div>
                        </div>


                        <h1>
                            CHARACTER CERTIFICATE
                        </h1>

                        <div className="certificate-meta">

                            <div className="text-muted">
                                Cert. No:
                                <span className="text-dark">
                                    &nbsp;{displayValue(formData.certificateNo)}
                                </span>
                            </div>                            

                        </div>
                        {/* CERTIFICATE BODY */}

                        <div className="certificate-body">

                            <p>

                                {formData.firstParagraph}

                                <b>
                                    &nbsp;
                                    {displayValue(formData.student)}
                                </b>

                                ,

                                son/daughter of

                                <b>
                                    &nbsp;
                                    {displayValue(formData.father)}
                                </b>


                                and


                                <b>
                                    &nbsp;
                                    {displayValue(formData.mother)}
                                </b>


                                ,

                                bearing Admission No.


                                <b>
                                    &nbsp;
                                    {displayValue(formData.admissionNo)}
                                </b>


                                ,


                                is/was a student of Class


                                <b>
                                    &nbsp;
                                    {displayValue(formData.className)}
                                    {" - "}
                                    {displayValue(formData.section)}
                                </b>


                                of


                                <b>
                                    &nbsp;
                                    SRINI THE PLAY SCHOOL & ACADEMY
                                </b>


                                .


                            </p>







                            <p>


                                During his/her entire period of association with this institution,


                                <b>

                                    &nbsp;
                                    {displayValue(formData.student)}

                                </b>


                                ,


                                {formData.secondParagraph}



                            </p>







                            <p>


                                {formData.thirdParagraph.replace(
                                    "the student",
                                    formData.student || "the student"
                                )}



                            </p>







                            <p>


                                Issued on:


                                <b>

                                    &nbsp;
                                    {formatDate(formData.issueDate)}

                                </b>


                            </p>



                        </div>









                        {/* FOOTER FIXED */}



                        <div className="certificate-footer">



                            <div>

                                Date :

                                {formatDate(formData.issueDate)}

                                <br />

                                Place :

                                {displayValue(formData.place)}

                            </div>






                            <div className="seal">


                                SEAL


                            </div>






                            <div>


                                __________________


                                <br />


                                PRINCIPAL


                            </div>




                        </div>





                    </div>


                </div>



            </div>







            <div className="no-print text-center">


                <button

                    className="btn btn-success mt-3"

                    onClick={() => window.print()}

                >

                    Print Certificate


                </button>



            </div>



        </div>


    )

}


export default CharacterCertificate;